import { render, staticRenderFns } from "./RDPV26.vue?vue&type=template&id=2b79f52e"
import script from "./RDPV26.vue?vue&type=script&lang=js"
export * from "./RDPV26.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports